import React, { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'


const OrderComponent = () => {
  const [cookies] = useCookies(["token"]);
  const token = cookies.token;
  const [phoneNumber, setPhoneNumber] = useState("");
  const [deriverylocation, setDeriverylocation] = useState("");
  const [orderedItems, setOrderedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [requestOk, setRequestOk] = useState(false);

  const location = useLocation();
  const navigate=useNavigate()
  const cartItems = location.state && location.state.cartItems; // Access cartItems from location.state
  // console.log(cartItems);
  useEffect(()=>{
        setOrderedItems(cartItems)
    },[cartItems])

    const transformPhoneNumber = (inputNumber) => {
      // Remove any non-digit characters (e.g., spaces, dashes)
      const cleanNumber = inputNumber.replace(/\D/g, '');
    
      if (cleanNumber.startsWith('0') && cleanNumber.length === 10) {
        // If the number starts with "0" and has 10 digits
        return `254${cleanNumber.slice(1)}`;
      } else if (cleanNumber.startsWith('+254') && (cleanNumber.length !== 13)) {
        // If the number starts with "+254" and has more than 13 digits or less than 13 digits, it is invalid
        return null;  
      } else if (cleanNumber.startsWith('0') && cleanNumber.length !== 10) {
        // If the number starts with "0",it should have 10 digits
        return null
      } else {
        // Otherwise, return null to indicate an invalid number
        return null;
      }
    };

  const handleOrder = async (e) => {
    e.preventDefault();

    const transformedPhoneNumber = transformPhoneNumber(phoneNumber);
     // Check if the phone number is valid
      if (transformedPhoneNumber === null) {
        // There is an error in the phone number
        setError("Enter a valid number");
        setTimeout(()=>{
          setError("");
        },[3000])
        return;
      }
    try {
      setIsLoading(true); // Set loading state to true

      const response = await fetch(
        "https://campus-closet-server.vercel.app/api/orders",
        {
          // Send a request to your server's payment endpoint
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            orderedItems,
            deriverylocation: deriverylocation,
            phoneNumber: phoneNumber,
          }),
        }
      );

      if (response.ok) {
        // Process the payment response or perform any necessary actions
        const orderResponse = await response.json();
        console.log(orderResponse.buyerDetails[0][0].full_name);
        localStorage.clear();
        toast.success("Order sent successfully! we will contact you soon", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        setRequestOk(
          `Request successful. we will contact you soon`
        );
        setTimeout(() => {
          setRequestOk("");
          navigate('/')
        }, [3000]);
        setDeriverylocation("");
        setPhoneNumber("");

        //Now its time to send the seller a notification
        if (orderResponse.buyerDetails.length > 0) {
          // Make another POST request to notify the owner
          try {
            const notifyResponse = await fetch(
              "https://mailing-server-six.vercel.app/api/notifyOwner",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  buyerDetails: orderResponse.buyerDetails,
                }),
              }
            );
      
            if (notifyResponse.ok) {
              console.log("Owner notified successfully");
            } else {
              console.error("Error notifying the owner");
            }
          } catch (error) {
            console.error("An error occurred while notifying the owner:", error);
          }
        }


      } else {
        throw new Error("order request failed");
      }
      setIsLoading(false); // Set loading state back to false
    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state back to false
      setError(true); // Set the error message
      setTimeout(() => {
        setError(false); // Set the error message
      }, [3000]);
    }
  };

  return (
  <section style={{ minHeight: `calc(100vh - 70px)` }}>
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4 text-center">Place an Order</h1>
      <div className="bg-white shadow-md rounded-lg p-6 mb-4">
        <h2 className="text-xl font-bold mb-4">Order Summary</h2>
        {orderedItems.map((item) => (
            <div key={item.pid} className="mb-4">
              <div className="flex justify-between mb-2">
                <span>Item Name</span>
                <span>{item.product_name}</span>
              </div>
              <div className="flex justify-between mb-2">
                <span>Item Price</span>
                <span>KSh{item.price}</span>
              </div>
            </div>
          ))}
        <div className="border-t border-gray-300 mt-2 pt-2">
            <div className="flex justify-between">
              <span className="font-bold">Total:</span>
              <span className="font-bold">KSh{cartItems.reduce((total, item) => total + item.price, 0)}</span>
            </div>
        </div>
      </div>
      <form onSubmit={handleOrder}>
            <div className="mb-4">
                <label htmlFor="phone" className="block text-gray-700 font-bold mb-2">
                    Phone Number:
                </label>
                <input
                    type="text"
                    id="phone"
                    className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your phone number"
                    value={phoneNumber}
                    required
                    onChange={(e) => setPhoneNumber(e.target.value)}
                />
                </div>
            <div className="mb-4">
                <label htmlFor="phone" className="block text-gray-700 font-bold mb-2">
                    Delivery Place
                </label>
                <input
                    type="text"
                    id="deriverylocation"
                    className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Any place within Baraton Metropolitan"
                    value={deriverylocation}
                    required
                    onChange={(e) => setDeriverylocation(e.target.value)}
                />
            </div>
            <div className="flex justify-center">
                <button type="submit"  className="bg-blue-500 text-white px-4 py-2 rounded font-bold">
                    {isLoading ? 'Processing...' : 'Order Now'}
                </button>
            </div>
        </form>
      {requestOk && <p className="text-green-500 font-bold">{requestOk}</p>}
      {error && <p className="text-red-500">Enter a valid number</p>}
    </div>
    <ToastContainer />
    </section>
  );
};

export default OrderComponent;
